import Sockette from 'sockette';
import {actions as spinnerActions} from '../reducers/actionSpinner';
import store from '../config/store';

export default class WebSocket {
    // @ts-ignore
    private static NOTIFICATION_URL = NOTIFICATION_URL;
    private static instance: any;
    static TYPES = {
        CREATE_TOUCHSTONE_RECORDS: "CREATE_TOUCHSTONE_RECORDS",
        SAVE_BO_INSTANCES: "SAVE_BO_INSTANCES",
        FILE_UPLOAD: "FILE_UPLOAD",
        FILE_EXPORT: "FILE_EXPORT",
        FILE_IMPORT: "FILE_IMPORT",
        ATTACHMENT_DOWNLOAD: "ATTACHMENT_DOWNLOAD",
        ATTACHMENT_DOWNLOAD_COMPLETED: "ATTACHMENT_DOWNLOAD_COMPLETED",
        ZIPPING_ATTACHMENTS: "ZIPPING_ATTACHMENTS",
        INTERRUPTED: "INTERRUPTED",
        SPECIFICATION_IMPORT: "SPECIFICATION_IMPORT",
        SPECIFICATION_EXPORT: "SPECIFICATION_EXPORT"
    };

    static open() {
        WebSocket.instance = new Sockette(WebSocket.NOTIFICATION_URL, {
            timeout: 5e3,
            maxAttempts: 10,
            onmessage: (msg: any) => {
                const data = JSON.parse(msg.data);
                switch (data.type) {
                    case WebSocket.TYPES.INTERRUPTED:
                    case WebSocket.TYPES.FILE_UPLOAD:
                    case WebSocket.TYPES.FILE_EXPORT:
                    case WebSocket.TYPES.FILE_IMPORT:
                    case WebSocket.TYPES.SAVE_BO_INSTANCES:
                    case WebSocket.TYPES.ATTACHMENT_DOWNLOAD:
                    case WebSocket.TYPES.ZIPPING_ATTACHMENTS:
                    case WebSocket.TYPES.SPECIFICATION_IMPORT:
                    case WebSocket.TYPES.SPECIFICATION_EXPORT:
                    case WebSocket.TYPES.CREATE_TOUCHSTONE_RECORDS:
                    case WebSocket.TYPES.ATTACHMENT_DOWNLOAD_COMPLETED:
                        store.dispatch({
                            type: spinnerActions.SET_ACTION_SPINNER_NOTIFICATION_PAYLOAD,
                            payload: {
                                message: data.message,
                                done: data.payload.done,
                                total: data.payload.total,
                                complete: (data.payload.done / data.payload.total * 100) || 0
                            }
                        });
                        break;
                }
            },
            onopen: e => console.log('Connected!', e),
            onreconnect: e => console.log('Reconnecting...', e),
            onmaximum: e => console.log('Stop Attempting!', e),
            onclose: e => console.log('Closed!', e),
            onerror: e => console.log('Error:', e)
        });
    }

    static close() {
        if (WebSocket.instance) {
            WebSocket.instance.close();
        }
    }
}




// WEBPACK FOOTER //
// ./app/config/ws.ts